/**
 * Shipping protection is added only at checkout redirect, never shown in cart UI.
 * Strip leftover lines when the shopper returns to the storefront.
 */
(function () {
  var HANDLES = ['shipping-protection', 'shipguard-shipping-protection'];
  var cleanupPromise = null;

  function isProtectionLine(item) {
    return item && HANDLES.indexOf(item.handle) !== -1;
  }

  function stripProtectionFromCart() {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var updates = {};
        var found = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (isProtectionLine(cart.items[i])) {
            updates[cart.items[i].variant_id] = 0;
            found = true;
          }
        }
        if (!found) {
          return { removed: false, cart: cart };
        }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (updated) {
            return { removed: true, cart: updated };
          });
      });
  }

  function updateCartIconBubble() {
    return fetch('/?section_id=cart-icon-bubble')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      })
      .catch(function () {});
  }

  function refreshCartItemsSection() {
    var cartItems = document.querySelector('cart-items');
    if (!cartItems || typeof cartItems.onCartUpdate !== 'function') {
      return Promise.resolve();
    }
    return cartItems.onCartUpdate();
  }

  function publishCartUpdate(cart) {
    if (typeof publish === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'shipping-protection',
      cartData: cart,
    });
  }

  function runCleanup() {
    if (cleanupPromise) return cleanupPromise;

    cleanupPromise = stripProtectionFromCart().then(function (result) {
      if (!result.removed) return result;

      var tasks = [updateCartIconBubble()];
      if (document.body.classList.contains('template-cart')) {
        tasks.push(refreshCartItemsSection());
      }

      return Promise.all(tasks).then(function () {
        publishCartUpdate(result.cart);
        return result;
      });
    });

    return cleanupPromise;
  }

  window.ShippingProtectionCart = {
    HANDLES: HANDLES,
    isProtectionLine: isProtectionLine,
    stripProtectionFromCart: stripProtectionFromCart,
    runCleanup: runCleanup,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runCleanup);
  } else {
    runCleanup();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      cleanupPromise = null;
      runCleanup();
    }
  });
})();
